module.exports = __webpack_public_path__ + "img/三星特级大师@3x.cf423411.png";